module.exports = __webpack_public_path__ + "assets/img/police.484da554.svg";